const updaterequest = {
	name: 'Update Requests',
	icon: 'fas fa-user-edit',
	fields: {},
}
export default updaterequest
